import React, {useEffect, useState} from 'react';
import {Modal} from 'react-bootstrap';
import {Trans} from 'react-i18next';
import _indexOf from 'lodash/indexOf';
import classnames from 'classnames';

export default function EditStoresModal({
  show,
  handleCloseModel,
  handleChooseModel,
  storeCategory = [],
  editStoreIds = [],
  disabledStoreIds = [],
}) {
  const [selectedStoreIds, setSelectedStoreIds] = useState([...editStoreIds]);

  const isAllSelected =
    new Set([...selectedStoreIds, ...disabledStoreIds]).size ===
    new Set(storeCategory.map(item => item.value)).size;

  const toggleStoreSelection = storeId => {
    setSelectedStoreIds(prevSelected =>
      prevSelected.includes(storeId)
        ? prevSelected.filter(id => id !== storeId)
        : [...prevSelected, storeId]
    );
  };

  const toggleAllStores = isChecked => {
    if (isChecked) {
      const enabledStoreIds = storeCategory
        .map(item => item.value)
        .filter(
          id =>
            !disabledStoreIds
              .filter(item => !editStoreIds.includes(item))
              .includes(id)
        );
      setSelectedStoreIds(enabledStoreIds);
    } else {
      setSelectedStoreIds([]);
    }
  };

  useEffect(() => {
    setSelectedStoreIds([...editStoreIds]);
  }, [editStoreIds]);

  return (
    <Modal
      centered
      show={show}
      onHide={() => {
        handleCloseModel(false);
      }}
      size="xl"
    >
      <Modal.Header closeButton={false}>
        <Modal.Title>
          <Trans i18nKey="p.s.uiconfiguration.userconsnt.assigned.locations.for.consent">
            Assign Locations for User Consent Content
          </Trans>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <label className="kt-checkbox kt-checkbox--brand">
            <input
              type="checkbox"
              checked={isAllSelected}
              onChange={e => toggleAllStores(e.target.checked)}
            />
            <Trans i18nKey="p.g.b.details.category.select.all">
              Select All
            </Trans>
            <span />
          </label>
        </div>
        <div className="d-flex">
          {storeCategory.map(item => {
            const isDisabled =
              _indexOf(
                disabledStoreIds.filter(item => !editStoreIds.includes(item)),
                item.value
              ) !== -1;
            const isChecked = selectedStoreIds.includes(item.value);

            return (
              <div className="pr-2" key={item.value}>
                <label
                  className={classnames('kt-checkbox kt-checkbox--brand', {
                    'kt-checkbox--disabled': isDisabled,
                  })}
                  htmlFor={`checkbox-${item.value}`}
                >
                  <input
                    type="checkbox"
                    id={`checkbox-${item.value}`}
                    value={item.value}
                    checked={isChecked}
                    disabled={isDisabled}
                    onChange={() => toggleStoreSelection(item.value)}
                  />
                  {item.label}
                  <span />
                </label>
              </div>
            );
          })}
        </div>
      </Modal.Body>
      <Modal.Footer className="text-right">
        <button
          type="button"
          className="btn btn-outline-secondary kt-margin-r-10 kt-margin-b-10"
          onClick={handleCloseModel}
        >
          <Trans i18nKey="c.f.simple.button.group.discard">Discard</Trans>
        </button>
        <button
          type="button"
          className="btn btn-primary kt-margin-r-10 kt-margin-b-10"
          onClick={() => {
            handleChooseModel(selectedStoreIds);
          }}
        >
          <Trans i18nKey="c.f.simple.button.group.save">Save</Trans>
        </button>
      </Modal.Footer>
    </Modal>
  );
}
